import Button from "../../base/Button";

const renderIcon = (color) => (
    <svg width="28px" height="24px" viewBox="0 0 28 24" version="1.1">
        <title>align-bottom</title>
        <desc>Created with Sketch.</desc>
        <defs />
        <g
            id="Lightsmap-2.0"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="square"
        >
            <g
                id="Select-Manual"
                transform="translate(-304.000000, -71.000000)"
                stroke={color}
            >
                <g id="toolbar" transform="translate(0.000000, 60.000000)">
                    <g
                        id="Group-9"
                        transform="translate(281.600000, 11.500000)"
                    >
                        <g
                            id="align-bottom"
                            transform="translate(23.115385, 0.000000)"
                        >
                            <path
                                d="M0.461538462,22.6153846 L26.3076923,22.6153846"
                                id="Shape"
                            />
                            <rect
                                id="Rectangle-path"
                                x="4.15384615"
                                y="0.461538462"
                                width="6.46153846"
                                height="16.6153846"
                            />
                            <rect
                                id="Rectangle-path"
                                x="16.1538462"
                                y="8.76923077"
                                width="6.46153846"
                                height="8.30769231"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

/**
 * Toolbar button for aligning selected lights to the bottom.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered align bottom button.
 */
const AlignBottomButton = (props) => (
    <Button {...props} renderIcon={renderIcon} />
);

export default AlignBottomButton;
